export default "__VITE_ASSET__Crg4TOKY__"